<template>
  <div class="main-content" id="container">
    <!--顶部-->
    <!-- <div class="read-head-banner">
      <div class="read_logo">鼎秀报刊检索平台</div>
    </div> -->
    <div class="wrapper_full">
      <el-row class= "control-bar" type="flex" justify="left">
        <el-col class="page-label">
            <span>标题： 【{{bookNameLimit}}】 </span>
            <span>&nbsp;&nbsp;总共：{{pageCount}} 页</span>
            <span>&nbsp;&nbsp; 当前：</span><span class="color_red font_w margin5"> {{parseInt(this.currentPage)}} 页</span>
        </el-col>
        <el-col class="page-button">
          <el-button type="text" icon="el-icon-view" @click="AutoPdfPage()" title="自动阅读"></el-button><!--el-icon-edit-->
          <el-button type="text" icon="iconfont icon-bill-line" @click="onClickPagerShowModel(1)" title="单页"></el-button>
          <el-button type="text" icon="iconfont icon-xianxing-_yuedu" @click="onClickPagerShowModel(2)" title="多页"></el-button>
          <el-button type="text" icon="el-icon-zoom-in" @click="onClickScaleDX()" title="放大"></el-button>
          <el-button type="text" icon="el-icon-zoom-out" @click="onClickscaleX()" title="缩小"></el-button>
          <el-button type="text" icon="iconfont icon-skip-left-line" @click="onClickPdfPage('pre')" title="上一页"></el-button>
          <el-button type="text" icon="iconfont icon-skip-right-line" @click="onClickPdfPage('next')" title="下一页"></el-button>
          <el-button type="text" icon="iconfont icon-edit-box-line" @click="onClickAddNode(0)" title="添加笔记"></el-button>
          <el-button type="text" icon="iconfont icon-book-read-line" @click="onClickShowLabel(0)" title="笔记列表"></el-button>
          <el-button type="text" icon="iconfont icon-award-fill" @click="onClickAddNode(1)" title="添加标签"></el-button>
          <el-button type="text" icon="iconfont icon-survey-line" @click="onClickShowLabel(1)" title="标签列表"></el-button>
          <el-button type="text" :icon="favoriteState" @click="onClickFavorite()" title="收藏"></el-button>
          <el-button type="text" icon="iconfont icon-fullscreen-exit-line" @click="requestFullScreen()" title="全屏"></el-button>
        </el-col>
        <el-col class="jump-pagenum">
          <el-input type="text" class="input_page" oninput="value=value.replace(/[^\d]/g,'')" v-model="jumpPageNum" placeholder="输入页码" clearable ></el-input>
        </el-col>
        <el-col class="jump-button">
          <el-button type="text" icon="el-icon-refresh" @click="setActivePage">跳转</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="pdf-read">
      <div v-if="showLabelForm == true" class="pdfread-note">
        <div class="node-title">
          笔记标题 
          <el-button type="text" icon="el-icon-close" style="float: right;margin-right: 20px;" @click="onClickShowLabelClose"></el-button></div>
        <div class="note-content">
          <ul>
            <li v-for="(oneItem,index) in nodeObjectList" :key="oneItem.id">
              <a @click="onClickNoteItem(oneItem.id,oneItem.nodePos)"><i class="iconfont icon-price-tag-3-line"/> {{ index }}. &nbsp;&nbsp;{{ oneItem.nodeLabel }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="pdfShowModelType == 1">
        <pdf :src="bookUrl"
        ref="pdf"
        :page="currentPage" @num-pages="pageCount = $event" 
        @progress="loadedRatio = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler"
        @link-clicked="currentPage = $event" id="pdfID" style="margin: auto;"></pdf>
      </div>
      <div v-else>
        <span class="pdf-pager" v-for="pagenum in [currentPage,currentPage+1]" :key="pagenum">
          <pdf :src="bookUrl"
          ref="pdf"
          :page="pagenum" @num-pages="pageCount = $event"
          @progress="loadedRatio = $event" @page-loaded="pagenum = $event" @loaded="loadPdfHandler"
          @link-clicked="pagenum = $event" id="pdfID" style="margin: auto;"></pdf>
        </span>
      </div>
    </div>

    <el-dialog :title="textMap[addNodeType]" :visible.sync="dialogFormVisible" width="40%">
      <el-form :rules="rules" ref="dataForm" :model="objectData" label-position="left" label-width="120px">
        <el-form-item label="当前页码" prop="nodePos">
          <!--  :disabled="true" -->
          <el-input v-model="objectData.nodePos"></el-input>
        </el-form-item>
        <el-form-item label="添加标题" prop="nodeLabel">
          <el-input v-model="objectData.nodeLabel"></el-input>
        </el-form-item>
        <el-form-item label="添加内容" prop="nodeContent">
          <el-input v-model="objectData.nodeContent"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveCreateData">确定</el-button>
      </div>
    </el-dialog>
    <!--底部-->
    <foot-template></foot-template>
  </div>
</template>

<script>
  import Vue from 'vue'
  import noteApi from '@/api/usernote'
  import resourceApi from "@/api/resource"
  import footTemplate from "../template/foot"
  import { Message,MessageBox } from 'element-ui'
  import imageRead from './imageread'
  import pdf from "vue-pdf"
  import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
  import readBanner from '@/assets/site-image/banner-read.jpg'

  export default {
    name: "readPage",
    components: {
      footTemplate,
      imageRead,
      pdf
    },
    data(){
      return{
        //url: "http://localhost:8080/bookvirtual/8ef221e60c66444984539a6afd19RjheZPXr/1c300a8ea3f04761bc65c7fd8a48QfrUvc5T/09011927.pdf",
        bookName:'',
        boodGuid:'',
        bookUrl: '',
        bookState: 0,
        favoriteState: 'iconfont icon-magic-fill',
        cursorDefault:"text",
        cursorHand:"pointer",
        currentPage:1,
        pageCount: 30,
        scale:100,
        AutoPage:false,
        AutoTime:1,
        jumpPageNum:1,
        addNodeType:1,
        showLabelForm: false,
        showLabelType: 1,
        pdfShowModelType:1,
        dialogFormVisible:false,
        textPreviewWay:true,
        tableLoading: false,
        readBanner:readBanner,
        objectData:{},
        nodeObjectList:[],
        queryEntity:{
          keyword: null,
          current: 1,
          pages: null,
          sizes: 20,
          total: 0,
          extInt: -1,
          extStr: '',
          orderField: "createDate",
        },
        textMap:['添加笔记','添加标签','图书收藏'],
        rules: {
          currentPage: [{ required: true, message: '标题不能为空。', trigger: 'blur' }],
          nodeLabel: [{ required: true, message: '标题不能为空。', trigger: 'blur' }],
        },
      }
    },
    created() {
      
      // this.vulomeData = this.$route.query;
      // if (this.vulomeData != null){
      //   this.queryEntity.keyword = this.vulomeData.volumeGuid;
      //   this.queryEntity.extInt = this.vulomeData.volumeIndexSort;
      //   this.pageIndex = parseInt(this.vulomeData.volumeIndexSort);
      // }
    },
    computed: {
      bookNameLimit() {
        const maxLength = 30; // 最大截取长度为10个字符
        if (this.bookName.length > maxLength) {
          let limtBookName = this.bookName.substring(0, maxLength) + '...'; // 超过最大长度则添加省略号
          console.log("limtBookName  ",limtBookName)
          return limtBookName
        } else {
          return this.bookName; // 未超过最大长度则直接返回原文本
        }
      }
    },
    mounted() {
      this.boodGuid = this.$route.query.bookGuid;
      this.bookUrl = this.$route.query.bookUrl;
      this.bookName = this.$route.query.bookName
      this.bookState = parseInt(this.$route.query.bookState)
      if (this.bookState == 0){
        this.favoriteState = 'iconfont icon-magic-line'
      } else{
        this.favoriteState = 'iconfont icon-magic-fill'
      }
      this.queryEntity.extStr = this.boodGuid
      console.log('this.query  ',this.$route.query)
      this.pdfSrc = pdf.createLoadingTask({ url: this.bookUrl,CMapReaderFactory});//解决中文乱码问题
      this.pdfSrc.promise.then((pdf) => {
        this.pageCount = pdf.numPages;
        console.log('count ',this.pageCount)
      })
    },
    methods:{
      toTop() {
        document.getElementById('container').scrollTop = 0
      }, 
      onClickNoteItem(nodeId,nodePos){
        this.currentPage = nodePos
        //this.showLabelForm = false
      },
      onClickShowLabelClose(){
        this.showLabelForm = false
      },
      onClickShowLabel(labelType){
        this.showLabelType = labelType
        this.queryEntity.extInt = labelType
        noteApi.getNoteByPageQuery(this.queryEntity).then(res => {
          this.nodeObjectList = res.data.data.list
          this.dialogFormVisible = false
        })
        
        this.showLabelForm = true
      },
      onClickPagerShowModel(modelType){
        this.pdfShowModelType = modelType
      },
      onClickFavorite(){
        if (this.bookState == 0){
          this.bookState = 1
        }else{
          this.bookState = 0
        }
        let paraData = {
          guid:this.boodGuid,
          state:this.bookState
        }
        resourceApi.updateStateByGuid(paraData).then(res => {
          if (this.bookState == 0){
            this.favoriteState = 'iconfont icon-magic-line'
            this.$message.success("图书收藏取消。")
          }else{
            this.favoriteState = 'iconfont icon-magic-fill'
            this.$message.success("图书收藏成功。")
          }
        })
      },
      onClickAddNode(addType){
        this.objectData = {}
        this.objectData.nodePos = this.currentPage
        this.addNodeType = addType
        this.dialogFormVisible = true
        this.$nextTick(() => this.$refs['dataForm'].clearValidate())
      },
      saveCreateData(){
        this.objectData.noteResourceGuid = this.boodGuid
        this.objectData.labelType = this.addNodeType
        console.log('this.objectData. ', this.objectData)
        noteApi.addUserNode(this.objectData).then(res => {
          this.dialogFormVisible = false
          this.$message.success("添加成功")
        })
      },
      //缩小
      onClickscaleX() {
          if (this.scale == 0) {
              return;
          }
          this.scale += -5;
          this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      },
      onClickScaleDX() {
        this.scale += 5;
        this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      },
      // 切换页数
      onClickPdfPage(val) {
          if (val === 'pre' && this.currentPage > 1) {
              // 切换后页面回到顶部
              this.currentPage--
              this.toTop()
          } else if (val === 'next' && this.currentPage < this.pageCount) {
              this.currentPage++
              this.toTop()
          } else if (val === 'first') {
              this.currentPage = 1
              this.toTop()
          } else if (val === 'last' && this.currentPage < this.pageCount) {
              this.currentPage = this.pageCount
              this.toTop()
          }
      },
      setActivePage(){
        this.currentPage = parseInt(this.jumpPageNum)
        this.toTop()
      },
      AutoPdfPage() {
          var AutoTime = this.AutoTime * 1000
          this.AutoPage = this.AutoPage == true ? false : true;
          if (this.AutoPage == true) {
              this.$message({
                  type: "success",
                  message: "自动播放启动 " + this.AutoTime + "S自动翻页",
              });
              this.timer = setInterval(() => {
                  console.log(this.currentPage);
                  if (this.currentPage == this.pageCount) {
                      this.currentPage = 1;
                  }
                  else {
                      this.currentPage++;
                  }
              }, AutoTime)
          }
          else {
              this.$message({
                  type: "success",
                  message: "自动播放停止",
              });
              clearInterval(this.timer);
          }


      },
      // pdf加载时
      loadPdfHandler(e) {
          // 加载的时候先加载第一页
          //this.currentPage = 1
      },
      //全屏
      requestFullScreen() {
          let de = document.documentElement
          if (de.requestFullscreen) {
              de.requestFullscreen()
          } else if (de.mozRequestFullScreen) {
              de.mozRequestFullScreen()
          } else if (de.webkitRequestFullScreen) {
              de.webkitRequestFullScreen()
          }
      },
      //退出全屏
      exitFullscreen() {
          let de = document
          if (de.exitFullscreen) {
              de.exitFullscreen()
          } else if (de.mozCancelFullScreen) {
              de.mozCancelFullScreen()
          } else if (de.webkitCancelFullScreen) {
              de.webkitCancelFullScreen()
          }
      },
      //全屏切换
      toFullOrExit() {
          this.isFull = !this.isFull
          if (this.isFull) {
              this.requestFullScreen()
          } else {
              this.exitFullscreen()
          }
      },
      
      clickTextPreviewWay(){
        if (this.textPreviewWay){
          this.previewIcon = "el-icon-view";
          this.textPreviewWay = false;
        }else{
          this.textPreviewWay = true;
          this.previewIcon = "el-icon-edit";
        }
      }
    }
  }
</script>

<style var="{selectFontSize}" rel="stylesheet/scss" lang="scss" scoped>
@import url('../../styles/common.css');
@import url('../../styles/main.css');

.control-bar{
  width: 100%;
  height: 50px;
  font-size: 16px;
  background-color:#f0e8d1;
  border-bottom: #d9cca7 solid 3px;
  align-items: center;
  justify-content: center;
}
.page-label{
  width:60%;
  font-size: 16px;
  line-height: 50px;
  margin-left: 20px;
}
.page-button{
  width: 40%;
  display: flex;
  align-items: center;
  button{
    width: 28px;
    height: 26px;
    line-height:26px;
    font-size: 14px;
    color: #333;
    border:#c2af7a solid 1px;
    border-radius: 3px;
    text-align: center;
    background-color:#faf3e0;
    display:flex;
    align-items:center;
    padding-left:5px;
  }
}
.input_page{
  height: 26px;
  line-height:26px;
}
/deep/ .el-input__inner{
    height: 26px;
    line-height:26px;
}
.jump-pagenum{
  width:60px;
}
.jump-button{
  width: 70px;
  button{
    color: black;
    width: 60px;
  }
}
.pdfread-note{
  width: 300px;
  height: 100%;
  float:left;
  border: 1px solid #000;
  background-color:#f0e8d1;
  opacity: 0.4;
  position: absolute;
  display: block;
  z-index: 1;
}
.node-title{
  height: 40px;
  line-height: 40px;
  background-color: #d9cca7;
  font-size: 16px;
  align-items: center;
  border-left: 1.0rem solid #f8e44c;
}

.note-content li{
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  border-left: 1.0rem solid #f0e8d1;
}
.pdf-read{
  width: 100%;
  height: 100%;
  overflow:auto;
}

.pdf-pager{
  float: left;
  width: 50%;
}

.page-text{
  width: 100%;
  height: 780px;
  position: relative;
  //margin-left: 40px;
  //margin-right: 40px;
  right: 10px;
  padding:20px 0;
  //margin:0 15px;
  font-size: var(selectFontSize);
  color: #333;
  //text-align: center;
  line-height: 1.8em;
  //writing-mode:lr-tb;
  writing-mode:tb-rl;
  text-indent : 2em;
}

</style>



// WEBPACK FOOTER //
// src/view/readpage/readpage.vue